import axios from 'axios';

export const getBackendHealth = (callback) => {
    const config = {
        url: 'api/health'
    };
    axios.request(config).then(
        response => response && callback(response.data)
    );
}